import { ComponentDataDestService } from '../component-data-dest.service';
import { ComponentDataSourceService } from '../../component-data-source/component-data-source.service';
import { tap } from 'rxjs';
import { environment } from '../../../environment/environment';

function toRecurrenceType(value: unknown): string {
  if (typeof value === 'boolean') {
    return value ? 'per_user' : 'calendar';
  }
  if (value === 'per_user') {
    return 'per_user';
  }
  return 'calendar';
}

function toResetOnFulfillment(value: unknown, recurrenceType: string): boolean {
  if (recurrenceType !== 'per_user') {
    return false;
  }
  if (typeof value === 'boolean') {
    return value;
  }
  if (typeof value === 'string') {
    return ['1', 'true', 'yes', 'on'].includes(value.toLowerCase());
  }
  return Boolean(value);
}

function normalizeCalendarAnchorDate(
  value: unknown,
  recurrenceType: string,
  unit: unknown,
  recurrenceValue: unknown
): string | null {
  if (recurrenceType !== 'calendar') {
    return null;
  }
  const u = String(unit ?? '').toLowerCase();
  const n = Number(recurrenceValue);
  if (u === 'full_period') {
    return null;
  }
  if (u === 'year' && n === 1) {
    return null;
  }
  if (value === null || value === undefined || value === '') {
    return null;
  }
  const date = String(value).slice(0, 10);
  if (u === 'year' && n > 1) {
    const year = parseInt(date.slice(0, 4), 10);
    if (Number.isFinite(year) && year > 0) {
      return `${year}-01-01`;
    }
  }
  return date;
}

function toInheritsMaintenanceVersionId(value: unknown): number | null {
  if (value === null || value === undefined || value === '') {
    return null;
  }
  const id = Number(value);
  return Number.isFinite(id) && id > 0 ? id : null;
}

function toGrantedVersionIds(value: unknown): number[] {
  if (!Array.isArray(value)) {
    return [];
  }
  return value
    .map((id) => Number(id))
    .filter((id) => Number.isFinite(id) && id > 0);
}

export function add_path_version(
  componentDataDestService: ComponentDataDestService,
  componentDataSourceService: ComponentDataSourceService,
  data: any
) {
  const uuid = data.uuid;
  
  const recurrence_type = toRecurrenceType(data.recurrence_type);
  
  const versionData = {
    name: data.name,
    required_maintenance_minutes: data.required_maintenance_minutes,
    recurrence_value: data.recurrence_value,
    recurrence_unit: data.recurrence_unit,
    recurrence_type,
    reset_on_fulfillment: toResetOnFulfillment(data.reset_on_fulfillment, recurrence_type),
    recurrence_calendar_anchor_date: normalizeCalendarAnchorDate(
      data.recurrence_calendar_anchor_date,
      recurrence_type,
      data.recurrence_unit,
      data.recurrence_value
    ),
    granted_version_ids: toGrantedVersionIds(data.granted_version_ids),
    inherits_maintenance_from_version_id: toInheritsMaintenanceVersionId(
      data.inherits_maintenance_from_version_id
    ),
    visibility: data.visibility
  };

  const request$ = componentDataDestService.http.post(`${environment.apiUrl}/paths/${uuid}/versions`, {
    version: versionData
  });

  // Use the helper function to handle store update
  return componentDataSourceService.updateStoreData(request$, 'educational_path_versions').subscribe({
    error: (error) => console.error('Error adding version:', error)
  });
} 